import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((muiTheme: Theme) => ({
    card: {
        width: "100%",
    },
    chartContainer: {
        backgroundColor:
            muiTheme.palette.mode === "dark"
                ? muiTheme.palette.emteria.background.paperDeep
                : muiTheme.palette.emteria.background.paper,
        borderRadius: muiTheme.spacing(1),
        padding: muiTheme.spacing(2),
    },
    chartLoading: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    activityName: {
        fontSize: 16,
    },
    deviceSummaryIndicator: {
        width: "4px",
        borderRadius: "18px",
        height: 46,
        marginRight: muiTheme.spacing(4),
    },
    dateContainer: {
        display: "flex",
        justifyContent: "flex-end",
        padding: 0,
    },
    groupNameContainer: {
        textAlign: "right",
    },
    managementContainer: {
        display: "flex",
        alignSelf: "flex-end",
        width: 360,
        gap: muiTheme.spacing(1),
    },
    noActivityText: {
        borderBottom: "none",
        padding: 0,
    },
}));
